/**
 * Ligne de cours de la maquette (`.visit` : heure + date courte, nom, « studio · coach », action à
 * droite), pour « Mes cours à venir » et « Mon historique » de Mon compte v2.
 */
import type { ReactNode } from 'react';
import type { ClientVisit } from 'types/client';
import { fmtDateShort, fmtTime, toDate } from '../lib/format';
import { visitName } from '../lib/visits';

export function VisitRow({
  visit,
  subline,
  aside,
  muted,
}: {
  visit: ClientVisit;
  /** Ligne sous le nom (« studio · coach » et compléments). */
  subline: ReactNode;
  /** Contenu à droite (étiquettes, boutons). */
  aside?: ReactNode;
  muted?: boolean;
}) {
  const start = toDate(visit.StartDateTime);
  return (
    <li className={`mmv2-acct-visit${muted ? ' mmv2-acct-visit--muted' : ''}`} data-visit-id={visit.Id}>
      <div className="mmv2-acct-visit__when">
        <b>{start ? fmtTime(start) : '—'}</b>
        <span>{start ? fmtDateShort(start) : ''}</span>
      </div>
      <div className="mmv2-acct-visit__what">
        <b>{visitName(visit)}</b>
        <span>{subline}</span>
      </div>
      {/* Colonnes marque | Voir | annulation ou issue, partagées par toutes les lignes de la liste (account.css). */}
      {aside ? <div className="mmv2-acct-visit__aside">{aside}</div> : null}
    </li>
  );
}

/**
 * « studio · coach » : séparateurs dessinés en CSS (account.css .mmv2-dots), masqués en début de ligne. Ni « · » seul
 * en fin de ligne (revue du 04/10), ni « · Mon spot » en tête de la ligne suivante (revue du 05/10).
 */
export function Dots({ parts }: { parts: Array<ReactNode | null | undefined | false> }) {
  const kept = parts.filter((p) => p !== null && p !== undefined && p !== false && p !== '');
  return (
    <span className="mmv2-dots-clip">
      <span className="mmv2-dots">
        {kept.map((p, i) => (
          <span key={i} className="mmv2-dots__item">
            {p}
          </span>
        ))}
      </span>
    </span>
  );
}
